/**
 * FIX-B35 (QX-670): keeps the dd/mm/yyyy text of ui/DateInput in step with the real field when the
 * field is uncontrolled. The field's own input/change events cover typing and the picker; a
 * form.reset() (also used by react-hook-form's reset) changes the value WITHOUT any event on the
 * field, so the form's `reset` event is followed too. That event fires BEFORE the values are reset,
 * hence the read is deferred to the next task.
 */
type Listenable = {
  addEventListener(type: string, fn: () => void): void;
  removeEventListener(type: string, fn: () => void): void;
};
export type SyncableField = Listenable & { value: string; form?: Listenable | null };

export function attachDateInputSync(
  el: SyncableField,
  onValue: (value: string) => void,
  defer: (fn: () => void) => void = (fn) => { setTimeout(fn, 0); },
): () => void {
  let live = true;
  const sync = () => { if (live) onValue(el.value); };
  const afterReset = () => defer(sync);
  const form = el.form ?? null;
  el.addEventListener('input', sync);
  el.addEventListener('change', sync);
  form?.addEventListener('reset', afterReset);
  return () => {
    live = false;
    el.removeEventListener('input', sync);
    el.removeEventListener('change', sync);
    form?.removeEventListener('reset', afterReset);
  };
}
